module.exports = __webpack_public_path__ + "img/7.81326e65.png";